import React from 'react';
import { useCollectionStateContext } from 'Context/CollectionStateContext';
import {
  FDList, FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import AuthFactorModal from '../AuthFactorModal';
import AuthenticationFactorListItem from '../AuthenticationFactorListItem';

const AuthenticationFactorList = ({ onMount, onSomethingEnabled }) => {
  const { collection } = useCollectionStateContext();

  const authFactorResources = collection.resources().list();
  const numberEnabled = authFactorResources.filter((res) => res.attr('enabled') === 'true').length;

  React.useEffect(() => {
    onMount(collection);
  }, []);

  React.useEffect(() => {
    onSomethingEnabled(numberEnabled);
  }, [numberEnabled]);

  return (
    <FDStack direction={'column'} spacing={0}>
      <FDStack direction={'column'} spacing={2}>
        <FDList>
          {authFactorResources.map((res) => (
            <AuthenticationFactorListItem
              key={res.attr('authenticationType')}
              authenticationFactorResource={res}
            />
          ))}
        </FDList>
      </FDStack>
      <AuthFactorModal />
    </FDStack>
  );
};

AuthenticationFactorList.defaultProps = {
  onMount: () => {},
  onSomethingEnabled: () => ({}),
};

AuthenticationFactorList.propTypes = {
  onMount: PropTypes.func,
  onSomethingEnabled: PropTypes.func,
};

export default AuthenticationFactorList;
